export const RssCrawlResultConstants = {
    FETCH_RSS_CRAWL_RESULT_PENDING: 'FETCH_RSS_CRAWL_RESULT_PENDING',
    FETCH_RSS_CRAWL_RESULT_GET_LIST_SUCCESS: 'FETCH_RSS_CRAWL_RESULT_GET_LIST_SUCCESS',
    FETCH_RSS_CRAWL_RESULT_ERROR: 'FETCH_RSS_CRAWL_RESULT_ERROR'
};